/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CommentPosition { 
    base_comment_id: string;
    base_comment_position: number;
    reply_comment_id?: string;
    reply_comment_position?: number;
}